// ! Lembrar de alinhar sempre ao que tem no BACKEND
const TransactionEnums = {
  ENTRADA: 1,
  TRANSFERENCIA: 2,
  SAIDA: 3,
};

export default TransactionEnums;
